/* eslint-disable import/no-unused-modules */

import DrawerModal from "./DrawerModal";

export default DrawerModal;
